import { Component, OnInit, Type, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LicenseService } from 'app/core/services/license.service';
import { Observable } from 'rxjs/Observable';
import { Subscription, Subject, ReplaySubject } from 'rxjs';
import { NotificationService } from 'app/core/services/notification.service';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { ContentUpdatedInfoEdcastComponent } from 'app/shared/components/modal/content-updated-info-edcast/content-updated-info-edcast.component';
import { CardConfigurationService } from 'app/core/components/workflow-new/course/configurations/card-configuration.service';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { MaterialStackContainerService, MaterialInfo } from 'app/core/components/workflow-new/material/material-stack-container/material-stack-container.service';

@Component({
  selector: 'itpx-material-stack-container',
  templateUrl: './material-stack-container.component.html',
  styleUrls: ['./material-stack-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialStackContainerComponent extends RxComponent implements OnInit {
  private eLearningCertificates: any[];
  private checkForUpdates$ = new Subject<string>();
  private state$ = new ReplaySubject<string>(1);
  private materialDetails$: Observable<MaterialInfo>;
  private classConfig: CardConfiguration;
  private platformClass: any;
  private sub: Subscription;
  private deliverables$ = new ReplaySubject<MaterialInfo>(1);
  private learnerCertificates$ = new ReplaySubject<Array<any>>(1);
  private certificates: Array<any>;
  private errorMessage: String;
  private openModal = new Subject<any>();
  private updateContent = new Subject<any>();
  private classInfo = new ReplaySubject<any>(1);
  profile: any;


  constructor(private licenseService: LicenseService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private certificateService: CertificateService,
    private modalService: SmartModalService,
    private cardConfiguration: CardConfigurationService,
    private service: MaterialStackContainerService,
    private detector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.state$.next('loading');

    this.openModal.subscribe(data => this.modalService.open(<Type<Component>>ContentUpdatedInfoEdcastComponent, {
      text: 'brandedPortal.deliverable.updated.confirm',
      text2: 'brandedPortal.deliverable.updated.confirm2',
      html: true,
      table: data.changedContents,
    }, 'Content updated', ModalSize.Md)
      .bindToLifecycle(this)
      .map(r => r.result)
      .subscribe(
        v => {
          if (v.length > 0) {
            this.state$.next('loading');
            this.updateContent.next({ assignmentId: data.assignmentId, contents: v });
          }
        }, err => {
          this.state$.next('ready');
        }
      ));

    this.updateContent
      .switchMap(result => this.licenseService.updateContent(result.assignmentId, result.contents).zip(Observable.of(result.assignmentId))
      )
      .neverError()
      .switchMap(([_, assignmentId]) => this.service.getMaterialDetails(assignmentId))
      .map(response => response.data)
      .neverError()
      .bindToLifecycle(this)
      .subscribe(deliverables => {
        this.deliverables$.next(deliverables);
        this.state$.next('ready');
      }, err => this.state$.next('error'));
    this.materialDetails$ = this.classInfo
      .switchMap(id => this.service.getMaterialDetails(id))
      .map(body => body.data)
      .catch(err => {
        this.router.navigate(['/app']);
        return <Observable<MaterialInfo>>Observable.empty();
      })
      .shareReplay(1);

    this.checkForUpdates$
      .switchMap(id => this.licenseService
        .verifyContentChange(id)
        .neverError()
        .zip(Observable.of(id)))
      .bindToLifecycle(this)
      .subscribe(([res, id]) => {
        this.checkContentUpdate(res, id);
      });

    this.sub = this.route.params.subscribe(params => {
      let assignmentId = params['assignmentId'];
      // this.update.next(assignmentId);
      this.classInfo.next(assignmentId);
    });

    this.materialDetails$.bindToLifecycle(this)
      .subscribe(details => {
        this.deliverables$.next(details);
        this.state$.next('ready');
        this.checkForUpdates$.next(details.material.id);
      });
  }

  onClicked(event$: any) {
    if (event$.id === 'updateCheck')
      this.checkForUpdates$.next(this.platformClass.id)
  }

  getType(course: any) {
    let c = this.cardConfiguration.getConf(course);
    c.cardWidth = '960';
    return c;
  }

  private checkContentUpdate(content: any, assignmentId: any) {
    if (content.data && content.data.length > 0) {
      this.openModal.next({ assignmentId: assignmentId, changedContents: content.data });
      this.detector.detectChanges();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/material-stack-container/material-stack-container.component.ts